/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsShareing: {
  name: 'shareing';
  data: string;
} = {
  name: 'shareing',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM10.5 3a2.5 2.5 0 1 1 .533 1.543L5.415 7.35a2.503 2.503 0 0 1 0 1.298l5.618 2.808a2.5 2.5 0 1 1-.448.894L4.967 9.543a2.5 2.5 0 1 1 0-3.085l5.618-2.81A2.503 2.503 0 0 1 10.5 3ZM3 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm8.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
